/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Delete_ConfirmInputs */

const en_lesson_delete_confirm = /** @type {(inputs: Lesson_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this lesson? This also removes its scheduled notifications. This can't be undone.`)
};

const he_lesson_delete_confirm = /** @type {(inputs: Lesson_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למחוק את השיעור הזה? פעולה זו תמחק גם את ההתראות המתוזמנות שלו. לא ניתן לבטל.`)
};

/**
* | output |
* | --- |
* | "Delete this lesson? This also removes its scheduled notifications. This can't be undone." |
*
* @param {Lesson_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_delete_confirm = /** @type {((inputs?: Lesson_Delete_ConfirmInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Delete_ConfirmInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_delete_confirm(inputs)
	return he_lesson_delete_confirm(inputs)
});